module.exports = __webpack_public_path__ + "img/3.f6d3d9d5.svg";